<template comments>
  <div v-if="show" class="act-popbox show">
    <div class="act-popbox-dialog">
      <div class="act-popbox-inner">
        <div class="act-popbox-hd">
          <h3 class="act-popbox-tit">
            <slot name="act-title"></slot>
          </h3>
        </div>
        <div class="act-popbox-cont">
          <slot name="act-cont"></slot>
        </div>
        <div class="act-popbox-ft">
          <div class="act-popbox-close" @click="close">
            <slot name="act-close"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="act-mask" @click="close"></div>
  </div>
</template>

<script>
import { dialogNoScroll } from '@/libs/utils';
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(value) {
      dialogNoScroll(value);
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('update:show', false);
    }
  }
};
</script>
